<template>
    <div>
        <!-- <section class="item-image">
            <div class="image">
                <img src="/image/store_items/utada_hikaru_hatsukoi.jpg" alt="画僝">
            </div>
        </section> -->

        <section id="item-info">
            <div class="item-title">{{ title }}</div>
            <div class="item-date">{{ wdate }}</div>
            <div class="item-type">{{ characters.playlist }}</div>
        </section>

        <section id="list">
            <ul>
                <li v-for="music in musics" v-bind:key="music.digicon_id">
                    <span class="title"><a :href="'/playlist/player/'+ playlist_id +'/' + music.digicon_id">{{ music.title }}</a></span>
                    <button class="btn btn-outline-dark ml-auto" @click="select(music.playlist_detail_id, $event)">{{ characters.remove_music_from_playlist }}</button>
                </li>
            </ul>
        </section>

        <section id="buttons" class="d-flex justify-content-center">
            <button class="btn btn-dark button" @click="deletePlaylist()">{{ characters.delete_playlist }}</button>
        </section>
    </div>
</template>

<script>
    export default {
        name: "playlist-detail",
        props: ['playlist_id', 'title', 'wdate', 'json_characters'],
        data: function () {
            return {
                musics: [],
                characters: Object,
            }
        },
        mounted() {
            axios.default
                .post('/playlist/detail/' + this.playlist_id)
                .then(response => {
                    console.log(response.data);
                    this.musics = response.data;
                });
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            select: function (s, event) {
                if (s) {
                    if(confirm(this.characters.delete_confirm)){
                        const id = Number(s);
                        location.href = `/playlist/remove/${id}`;
                    }
                }
            },
            toDate: function (datetime) {
                let year = datetime.slice(0, 4);
                let month = datetime.slice(5, 7);
                let day = datetime.slice(8, 10);
                return year + "." + month + "." +day;
            },
            deletePlaylist: function () {
                if(confirm(this.characters.delete_confirm)){
                    location.href=`/playlist/delete/${this.playlist_id}`;
                }
            }
        }

    }
</script>

<style scoped>

</style>
